<!-- eslint-disable max-len -->
<template>
  <div id="modal-indexes">
    <h3 class="title-modal">Delete Index</h3>

    <!-- Information -->
    <div class="information">
      <img
        src="@/assets/icon/info.svg"
        alt="information-icon"
      >
      <div class="d-flex flex-column">
        <p class="information-title">Information</p>
        <p class="information-desc">
          Please confirm delete index with OTP code from your email.
        </p>
      </div>
    </div>

    <!-- OTP -->
    <div class="wrap-otp">
      <label>OTP CODE</label>

      <div class="input-otp-wrap">
        <input
          v-for="(otp, index) in Object.keys(otpData)"
          v-model="otpData[otp]"
          :key="otp"
          :ref="`inputOtpRef${index}`"
          :tab-index="index"
          :disabled="isDisabledInputOtp"
          class="otp"
          type="text"
          maxlength="1"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          @keyup="handleInput"
          @paste="handlePaste"
        >
      </div>

      <div class="d-flex flex-column align-items-end mt-2">
        <p
          v-if="!isRequestOTP"
          class="request-otp"
          @click="requestOTP"
        >
          Request OTP
        </p>

        <p
          v-if="isRequestOTP && isExpired"
          class="text-valid-otp"
        >
          The code has expired, <span @click="requestOTP">Resend a new code</span>
        </p>

        <p
          v-if="isRequestOTP && !isExpired"
          class="text-valid-otp"
        >
          Code is valid for {{ timerExpired }} minutes
        </p>

        <div
          v-if="isRequestOTP && !isExpired"
          class="didnt-get-otp"
        >
          Didn’t receive code?
          <span
            :style="{
              opacity: timerCountReqNewOtp > 0 ? 0.6 : 1,
              cursor: timerCountReqNewOtp > 0 ? 'not-allowed' : 'pointer'
            }"
            @click="requestOTP"
          >
            Resend a new code
          </span>
          <span
            v-if="timerCountReqNewOtp > 0"
            :style="{
              opacity: timerCountReqNewOtp > 0 ? 0.6 : 1,
              cursor: timerCountReqNewOtp > 0 ? 'not-allowed' : 'pointer'
            }"
          >
            ({{ timerCountReqNewOtp }}s)
          </span>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end mt-4">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        :disabled="!isFilledOtp"
        class="button-red"
        @click="deleteIndexes"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    indexesName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      otpData: { a: '', b: '', c: '', d: '', e: '', f: '' },
      isDisabledInputOtp: true,
      otpToken: null,

      // Countdown resend otp
      isRequestOTP: false,
      isDisabledResendOTP: false,
      resendNewOtp: false,
      timerCountReqNewOtp: 0,

      // Countdown expired
      isExpired: false,
      durationExpired: 0,
      timerExpired: '',
      timerExpFunction: null,
    };
  },

  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),

    isFilledOtp() {
      return !!(this.otpData.a &&
        this.otpData.b &&
        this.otpData.c &&
        this.otpData.d &&
        this.otpData.e &&
        this.otpData.f);
    },

    otp() {
      return `${this.otpData.a}${this.otpData.b}${this.otpData.c}${this.otpData.d}${this.otpData.e}${this.otpData.f}`;
    },
  },

  methods: {
    ...mapActions('jStoreJoana', ['getRequestOtpIndexes', 'removeIndexes']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),

    async requestOTP() {
      if (!this.isDisabledResendOTP) {
        this.otpData = { a: '', b: '', c: '', d: '', e: '', f: '' };
        const res = await this.getRequestOtpIndexes(this.dataset_data.id);
        if (!res.error) {
          this.isDisabledInputOtp = false;
          this.isRequestOTP = true;
          this.isExpired = false;
          this.otpToken = res.data.otp_token;
          this.handleTimerReqNewOtp();
          this.handleTimerExpired(res.data.expired_timestamp);
          setTimeout(() => {
            this.$refs.inputOtpRef0[0].focus();
          }, 300);
        }
      }
    },

    async deleteIndexes() {
      const payload = {
        id: this.dataset_data.id,
        name: this.indexesName,
        payload: {
          otp: this.otp,
          otp_token: this.otpToken,
        },
      };

      const res = await this.removeIndexes(payload);
      if (!res.error) {
        this.$emit('close-modal');
        this.$emit('refresh-data');
      } else {
        this.hideLoading();
        this.toggleProblem(res.message);
      }
    },

    handleInput(e) {
      // Back to previous otp input
      if (e.keyCode === 37 && e.target.previousElementSibling) {
        e.preventDefault();
        e.target.previousElementSibling.focus();
      }

      // Next to previous otp input
      if (e.keyCode === 39 && e.target.nextElementSibling) {
        e.preventDefault();
        e.target.nextElementSibling.focus();
      }

      // Delete otp input
      if (e.keyCode === 8 && e.target.value === '' && e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }

      // Handle if number inputed, focus to next input
      if (e.keyCode >= 48 && e.keyCode <= 57 && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    },

    handlePaste(e) {
      const data = e.clipboardData.getData('text');
      const otpKeys = Object.keys(this.otpData);

      otpKeys.forEach((item, i) => {
        this.otpData[item] = data[i];
      });

      e.target.blur();
    },

    handleTimerReqNewOtp() {
      this.timerCountReqNewOtp = 30;
      this.isDisabledResendOTP = true;
      const timer = setInterval(() => {
        this.timerCountReqNewOtp -= 1;

        if (this.timerCountReqNewOtp === 0) {
          clearInterval(timer);
          this.isDisabledResendOTP = false;
        }
      }, 1000);
    },

    handleTimerExpired(expired) {
      const now = new Date().getTime();
      const distance = new Date(expired).getTime() - now;
      const duration = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      clearInterval(this.timerExpFunction);
      this.timerExpFunction = null;
      this.durationExpired = 60 * (duration + 1);
      this.timerExpired = this.$moment(this.durationExpired * 1000).format('mm:ss');
      this.timerExpFunction = setInterval(() => {
        this.durationExpired -= 1;
        this.timerExpired = this.$moment(this.durationExpired * 1000).format('mm:ss');
        if (this.durationExpired === 0) {
          clearInterval(this.timerExpFunction);
          this.isExpired = true;
        }
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/partials/modalDeleteIndexes.vue